import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicPagination from "./PaginationComponents/BasicPagination";
import BasicPaginationSizes from "./PaginationComponents/BasicPaginationSizes";
import PaginationColors from "./PaginationComponents/PaginationColors";
import PaginationShape from "./PaginationComponents/PaginationShape";
import OutlinedPagination from "./PaginationComponents/OutlinedPagination";
import PaginationWithIcons from "./PaginationComponents/PaginationWithIcons";
import TableViewPagination from "./PaginationComponents/TableViewPagination";
import DisabledPagination from "./PaginationComponents/DisabledPagination";

const PaginationPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Pagination"}
        description={
          "The Pagination component enables the user to select a specific page from a range of pages."
        }
      />
      <Divider light />
      <BasicPagination />
      <BasicPaginationSizes />
      <PaginationColors />
      <PaginationShape />
      <OutlinedPagination />
      <PaginationWithIcons />
      <TableViewPagination />
      <DisabledPagination />
    </Paper>
  );
};

export default PaginationPage;
